import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _approveMemberRequest = {};
var _approveMemberResponse = {};
var _batchGetMembersRequest = {};
var _batchGetMembersResponse = { members: '_member' };
var _blockMemberRequest = {};
var _blockMemberResponse = {};
var _changeLoginEmailRequest = {};
var _changeLoginEmailResponse = { member: '_member' };
var _customField = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
};
var _deleteMemberRequest = {};
var _deleteMemberResponse = {};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getAuthorizedPagesRequest = {};
var _getAuthorizedPagesResponse = {};
var _getCurrentMemberRequest = {};
var _getMemberRequest = {};
var _getMemberResponse = { member: '_member' };
var _getMemberRoleRequest = {};
var _getMemberRoleResponse = {};
var _getMemberRolesRequest = {};
var _getMemberRolesResponse = {};
var _getResetPasswordLinkRequest = {};
var _getResetPasswordLinkResponse = {};
var _getUserMembershipsRequest = {};
var _getUserMembershipsResponse = {};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _listMembersRequest = {};
var _listMembersResponse = { members: '_member' };
var _loginRequest = {};
var _loginResponse = { member: '_member' };
var _makeMemberOfflineRequest = {};
var _makeMemberOfflineResponse = {};
var _member = {
    creationDate: 'google.protobuf.Timestamp',
    lastUpdateDate: 'google.protobuf.Timestamp',
    lastLoginDate: 'google.protobuf.Timestamp',
    customFields: '_customField',
    picture: '_image',
};
var _memberContactInfo = { customFields: '_customField' };
var _queryMembersRequest = {};
var _queryMembersResponse = { members: '_member' };
var _registerRequest = { contactInfo: '_memberContactInfo' };
var _registerResponse = { member: '_member' };
var _resetPasswordRequest = {};
var _resetPasswordResponse = {};
var _searchRequest = {};
var _searchResponse = { members: '_member' };
var _sendSetPasswordEmailRequest = {};
var _sendSetPasswordEmailResponse = {};
var _socialLoginRequest = {};
var _updateMemberRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    member: '_member',
};
var _updateMemberResponse = { member: '_member' };
function resolveWixMembersApiV1MembersServiceUrl(opts) {
    var domainToMappings = {
        'users._base_domain_': [
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/google1474e9a8a98de860.html',
                destPath: '/view/google/google1474e9a8a98de860.html',
            },
        ],
        'sslusers._base_domain_': [
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/google1474e9a8a98de860.html',
                destPath: '/view/google/google1474e9a8a98de860.html',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-sm',
                destPath: '/api/tokens',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-sm-webapp/members/v1/auth',
                destPath: '/v1/auth',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-sm',
                destPath: '/api/tokens',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/corvid/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/blacklivesmatter/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm',
                destPath: '/api',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wow/bulx/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/wow/data-hub/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wow/bulx/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/wow/data-hub/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wow/bulx/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/wow/data-hub/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/corvid/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm',
                destPath: '/api/tokens',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/auth',
                destPath: '/v1/auth',
            },
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'bo._base_domain': [
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixMembersApiV1AuthServiceUrl(opts) {
    var domainToMappings = {
        'users._base_domain_': [
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/google1474e9a8a98de860.html',
                destPath: '/view/google/google1474e9a8a98de860.html',
            },
        ],
        'sslusers._base_domain_': [
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/google1474e9a8a98de860.html',
                destPath: '/view/google/google1474e9a8a98de860.html',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-sm',
                destPath: '/api/tokens',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-sm-webapp/members/v1/auth',
                destPath: '/v1/auth',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-sm',
                destPath: '/api/tokens',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/corvid/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/blacklivesmatter/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm',
                destPath: '/api',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wow/bulx/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/wow/data-hub/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wow/bulx/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/wow/data-hub/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wow/bulx/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/wow/data-hub/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/corvid/api/wix-sm/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/wix-sm',
                destPath: '/api/tokens',
            },
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/wix-sm-webapp',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/auth',
                destPath: '/v1/auth',
            },
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/wix-sm',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
        'bo._base_domain': [
            {
                srcPath: '/_api/wix-sm/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Registers new site member. */
export function register(payload) {
    var _a = serializer(_registerRequest, {
        _customField: _customField,
        _memberContactInfo: _memberContactInfo,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_registerResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __register(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.AuthService.Register',
            url: resolveWixMembersApiV1AuthServiceUrl({
                protoPath: '/api/v1/auth/register',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __register.fromReq = fromReq;
    __register.__isAmbassador = true;
    return __register;
}
/**
 * Registers new site member.
 * This will try to connect the member to an existing contact, or create a new one in case no matches were found.
 *
 * To resend email with `otp` code, please provide `emailVerification` with `verificationId` only, and no `otp`.
 * It will skip recaptcha and resend the code to the given email.
 */
export function signup(payload) {
    var _a = serializer(_registerRequest, {
        _customField: _customField,
        _memberContactInfo: _memberContactInfo,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_registerResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __signup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.AuthService.Signup',
            url: resolveWixMembersApiV1AuthServiceUrl({
                protoPath: '/api/v1/auth/signup',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __signup.fromReq = fromReq;
    __signup.__isAmbassador = true;
    return __signup;
}
/** Logs a member in with an email and password. */
export function login(payload) {
    var _a = serializer(_loginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_loginResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __login(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.AuthService.Login',
            url: resolveWixMembersApiV1AuthServiceUrl({
                protoPath: '/api/v1/auth/login',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __login.fromReq = fromReq;
    __login.__isAmbassador = true;
    return __login;
}
/**
 * Creates a link to reset a site member's password.
 *
 * The returned link must be provided to the site member,
 * who must click the link and provide a new password.
 * The link is valid for one use, up to two weeks from when it is created.
 */
export function getResetPasswordLink(payload) {
    var _a = serializer(_getResetPasswordLinkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getResetPasswordLinkResponse, {}).fromJSON;
    function __getResetPasswordLink(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.AuthService.GetResetPasswordLink',
            url: resolveWixMembersApiV1AuthServiceUrl({
                protoPath: '/v1/auth/members/{contactId}/reset-password-link',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getResetPasswordLink.fromReq = fromReq;
    __getResetPasswordLink.__isAmbassador = true;
    return __getResetPasswordLink;
}
/**
 * Sends a site member an email with a link to set their password.
 *
 * The set password link is valid for 3 hours,
 * and it can be used only once.
 * If the link expires, the original password remains.
 */
export function sendSetPasswordEmail(payload) {
    var _a = serializer(_sendSetPasswordEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendSetPasswordEmailResponse, {}).fromJSON;
    function __sendSetPasswordEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.AuthService.SendSetPasswordEmail',
            url: resolveWixMembersApiV1AuthServiceUrl({
                protoPath: '/v1/auth/members/send-set-password-email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendSetPasswordEmail.fromReq = fromReq;
    __sendSetPasswordEmail.__isAmbassador = true;
    return __sendSetPasswordEmail;
}
/**
 * Reset member password
 *
 * Replaces the member password with a random password and it requires the member to reset his password to login
 */
export function resetPassword(payload) {
    var _a = serializer(_resetPasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resetPasswordResponse, {}).fromJSON;
    function __resetPassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.AuthService.ResetPassword',
            url: resolveWixMembersApiV1AuthServiceUrl({
                protoPath: '/v1/auth/members/reset-password',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resetPassword.fromReq = fromReq;
    __resetPassword.__isAmbassador = true;
    return __resetPassword;
}
/** Logs a member in with a social provider. */
export function socialLogin(payload) {
    var _a = serializer(_socialLoginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_loginResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __socialLogin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.AuthService.SocialLogin',
            url: resolveWixMembersApiV1AuthServiceUrl({
                protoPath: '/api/v1/auth/social-login',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __socialLogin.fromReq = fromReq;
    __socialLogin.__isAmbassador = true;
    return __socialLogin;
}
/**
 * Returns a list of members according to:
 * - Pagination: `offset`, `limit`
 * - Order: by some of the following fields: `id`, `login_email`, `status`, `language`, `date_created`, `last_update_date`, `flags`, `name`, `first_name`, `last_name`, `nickname`, `email_verified`, `privacy_status`
 * - Optional filter by `SiteMemberStatus`
 */
export function list(payload) {
    var _a = serializer(_listMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMembersResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.MembersService.List',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/**
 * Returns a list of members according to search and filter inputs:
 * - Pagination: `offset`, `limit`
 * - Optional filter by `group_id` `SiteMemberStatus`
 * - Optional search by `nickname`
 * - Order: by `date_created`
 */
export function search(payload) {
    var _a = serializer(_searchRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __search(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.MembersService.search',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/search',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __search.fromReq = fromReq;
    __search.__isAmbassador = true;
    return __search;
}
/** Returns information about a current member (by authorization header) */
export function getCurrent(payload) {
    var _a = serializer(_getCurrentMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __getCurrent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.MembersService.GetCurrent',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrent.fromReq = fromReq;
    __getCurrent.__isAmbassador = true;
    return __getCurrent;
}
/** Returns information about a particular member */
export function get(payload) {
    var _a = serializer(_getMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.MembersService.Get',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
/** Returns all user memberships */
export function getUserMemberships(payload) {
    var _a = serializer(_getUserMembershipsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUserMembershipsResponse, {}).fromJSON;
    function __getUserMemberships(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.MembersService.GetUserMemberships',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/users/{userId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserMemberships.fromReq = fromReq;
    __getUserMemberships.__isAmbassador = true;
    return __getUserMemberships;
}
/**
 * Returns member role.
 * This endpoint is needed for migration from this API to umbrella API, because umbrella API does not expose role.
 * Accepts siteMemberId as id param, which can be: contactId, userId
 */
export function getRole(payload) {
    var _a = serializer(_getMemberRoleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberRoleResponse, {}).fromJSON;
    function __getRole(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.MembersService.GetRole',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/{id}/role',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRole.fromReq = fromReq;
    __getRole.__isAmbassador = true;
    return __getRole;
}
/**
 * Returns members roles.
 * This endpoint is needed for migration from this API to umbrella API, because umbrella API does not expose role.
 * Accepts siteMemberId as id params, which can be: contactId, userId
 */
export function getRoles(payload) {
    var _a = serializer(_getMemberRolesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberRolesResponse, {}).fromJSON;
    function __getRoles(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.MembersService.GetRoles',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/roles',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRoles.fromReq = fromReq;
    __getRoles.__isAmbassador = true;
    return __getRoles;
}
/** Returns information about a list member */
export function batchGet(payload) {
    var _a = serializer(_batchGetMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_batchGetMembersResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __batchGet(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.MembersService.BatchGet',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/batch-get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __batchGet.fromReq = fromReq;
    __batchGet.__isAmbassador = true;
    return __batchGet;
}
export function getAuthorizedPages(payload) {
    var _a = serializer(_getAuthorizedPagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAuthorizedPagesResponse, {}).fromJSON;
    function __getAuthorizedPages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'GET',
            methodFqn: 'wix.members.api.v1.MembersService.GetAuthorizedPages',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/authorize/{siteId}/pages',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAuthorizedPages.fromReq = fromReq;
    __getAuthorizedPages.__isAmbassador = true;
    return __getAuthorizedPages;
}
/**
 * Update fields of an existing member
 * - Possible fields are: `imageUrl`, `nickname`, `privacyStatus`, `slug`
 */
export function update(payload) {
    var _a = serializer(_updateMemberRequest, { _customField: _customField, _focalPoint: _focalPoint, _image: _image, _member: _member }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMemberResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'PATCH',
            methodFqn: 'wix.members.api.v1.MembersService.Update',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/**
 * Changes a member's login email address.
 *
 * Members are typically associated with a contact, each having a distinct member and contact ID. When passing the ID as a parameter, avoid presuming the IDs are identical since they represent separate entities.
 */
export function changeLoginEmail(payload) {
    var _a = serializer(_changeLoginEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changeLoginEmailResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __changeLoginEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'PATCH',
            methodFqn: 'wix.members.api.v1.MembersService.ChangeLoginEmail',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/{id}/change-login-email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changeLoginEmail.fromReq = fromReq;
    __changeLoginEmail.__isAmbassador = true;
    return __changeLoginEmail;
}
/** Returns a list of members, given the provided paging, sort and filter */
export function query(payload) {
    var _a = serializer(_queryMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMembersResponse, {
        _customField: _customField,
        _focalPoint: _focalPoint,
        _image: _image,
        _member: _member,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.MembersService.Query',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/** Delete a member by id */
export function _delete(payload) {
    var _a = serializer(_deleteMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'DELETE',
            methodFqn: 'wix.members.api.v1.MembersService._Delete',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/**
 * Approves a pending member using an ID, email address or approval token.
 *
 * Tokens must be approved within 30 hours of token creation.
 * Use the `approvalToken` parameter returned from the
 * [`register()`](#register) function when approving a member by `token`.
 *
 * > **Note:**
 * > A new member's status is `"PENDING"` when the site's membership policy is set to manual approval.
 * > To learn more about setting your site's membership approval policy, see
 * > [Editing Your Member Signup Settings](https://support.wix.com/en/article/editing-your-member-signup-settings-for-the-default-form).
 *
 * Members are typically associated with a contact, each having a distinct member and contact ID. When passing the ID as a parameter, avoid presuming the IDs are identical since they represent separate entities.
 */
export function approve(payload) {
    var _a = serializer(_approveMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_approveMemberResponse, {}).fromJSON;
    function __approve(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.MembersService.Approve',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __approve.fromReq = fromReq;
    __approve.__isAmbassador = true;
    return __approve;
}
/**
 * Blocks a member from logging in to the site using an ID or email address.
 *
 * To unblock the member and allow them to log in to the site, use the [`approve()`](#approve) function.
 */
export function block(payload) {
    var _a = serializer(_blockMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_blockMemberResponse, {}).fromJSON;
    function __block(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.MembersService.Block',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/block',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __block.fromReq = fromReq;
    __block.__isAmbassador = true;
    return __block;
}
/**
 * Make member offline.
 * After this action, member `status` field is set to `OFFLINE_ONLY`.
 * Offline member cannot log into a site. Member is not visible in Business Manager site members list.
 */
export function makeMemberOffline(payload) {
    var _a = serializer(_makeMemberOfflineRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_makeMemberOfflineResponse, {}).fromJSON;
    function __makeMemberOffline(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members.v1.member',
            method: 'POST',
            methodFqn: 'wix.members.api.v1.MembersService.MakeMemberOffline',
            url: resolveWixMembersApiV1MembersServiceUrl({
                protoPath: '/api/v1/members/{id}/make-offline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __makeMemberOffline.fromReq = fromReq;
    __makeMemberOffline.__isAmbassador = true;
    return __makeMemberOffline;
}
//# sourceMappingURL=http.impl.js.map